// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Merriweather_577ed0', '__Merriweather_Fallback_577ed0'"},"className":"__className_577ed0"};